<template>
  <co-pic
    id="picWrapper"
    :src="src"
    :data="data"
    :check-permission="checkPermission"
    :is-original="isOriginal"
    :is-delivery="isDelivery"
    @picLoad="picLoad"
    @getOriginData="getOriginData"
  >
    <!--外链下载 iframe-->
    <iframe
      id="download-iframe"
      src="javascript:false;"
      width="0"
      heigth="0"
      border="none"
      style="display:none"
    />
    <!--loading-->
    <div
      slot="loading"
      class="pic-loading"
    >
      <div class="pic-loading-icon" />
      <div
        class="pic-loading-bg"
        :style="{backgroundImage: `url(${src})`}"
      />
    </div>
    <!--error-->
    <div
      slot="error"
      class="pic-error"
    >
      <!-- 异常预览提示 -->
      <bs-abnormal
        :data="data"
        :type="abnormalType"
        @abnormal="abnormal"
      />
    </div>
  </co-pic>
</template>
<script>
import _$ from 'js/api/getdata'
import coPic from 'components/common/pic/index.vue'
import { getSizeNum, isHasAuth } from 'js/util/util'
import { linkDownLoad } from 'js/api/download/linkDown.js'
import { bsFileDownLoad } from 'js/api/download/download.js'
import { EventBus } from "js/util/event-bus.js"
import bsAbnormal from 'components/business/abnormal/index.vue'

export default {
  components: {
    coPic,
    bsAbnormal,
  },
  props: {
    /**
         * metaData的信息
         */
    data: {
      type: Object,
      default: () => ({}),
    },
    /**
         * 是否是外链
         */
    isDelivery: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      src: '', // 预览地址
      abnormalType: 'loadFail', // 异常
      previewType: '', //是否原图: 是：original；否：''
      itemChange: false,
    }
  },
  mounted() {
    // 禁止右键
    document.getElementById('picWrapper').oncontextmenu = function (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    EventBus.$on('itemChange', (bool) => {
      this.itemChange = bool
    })
  },
  beforeDestroy() {
    EventBus.$off('itemChange')
  },
  methods: {
    getOriginData(data) {
      this.previewType = data.previewType
      this.itemChange = false
      this.$emit('getOriginData', data)
    },
    // 文件切换预处理
    startPreview() {
      this.src = ''
    },
    getDeliveryPicUrl() {
      const { data } = this
      this.src = data.preview_url || '#'
      if (this.src == '#') {
        this.abnormalType = 'oversize'
        return
      }
      this.abnormalType = 'loadFail'
    },
    /**
         *获取压缩图片的地址
         */
    previewDone(data) {
      if (this.itemChange) {
        this.previewType = ''
      }
      this.src = this.previewType ? `${data.stat_url}&is_log=true&previewType=${this.previewType}` : `${data.stat_url}&is_log=true`
    },
    previewFail(err) {
      this.abnormalType = 'loadFail'
      this.$emit('loadFail', 'loadFail')
    },
    /**
         * 是否已经是原图
         */
    isOriginal() {
      return false
    },
    /**
         * 异常操作
         */
    abnormal(key) {
      const cfg = {
        download: 'downloadPic', // download
        refresh: 'refreshPic', // refresh
      }
      if (cfg[key]) {
        this[cfg[key]]()
      }
    },
    // refresh pic
    refreshPic() {
      this.src = ''
      this.$nextTick(() => {
        this.startPreview()
      })
    },
    // 下载图片
    downloadPic() {
      if (this.isDelivery) {
        this.deliveryDownFile(this.data)
      } else {
        this.previewDownFile()
      }
    },
    /**
         * 预览下载
         */
    previewDownFile() {
      // 预览下载图片
      const downFile = { isDir: false, content: [this.data] }
      bsFileDownLoad(downFile)
    },
    /**
         * 外链下载
         */
    deliveryDownFile(data) {
      if (Object.keys(data).length < 1) {
        // 弹窗提示警告信息
        this.$toast.simpleShow('目标文件禁止此操作', 'warn')
        return
      }
      const shareInfo = {
        isSecurity: data.shareInfo.isSecurity || false, // 安全外链
        isApprove: data.shareInfo.isApprove || false, // 审批外链
        isTrial: data.shareInfo.isTrial || false, // 体验用户
      }
      if (shareInfo.isTrial) {
        // 弹窗提示警告信息
        this.$toast.simpleShow('体验版本不支持下载，请升级版本', 'warn')
        return
      }
      // 下载数据
      linkDownLoad(shareInfo, [data], false, () => {})
    },
    /**
         * check 下载权限
         */
    canDownload() {
      const accessMode = this.data.access_mode
      return isHasAuth(accessMode, 'download')
    },
    /**
         * 检测是否有权限
         */
    checkPermission() {
      // 外链的原图没有走下载，是通过拼接query实现的
      if (this.isDelivery) {
        return true
      }
      return this.canDownload()
    },
    /**
         * 拼接query到url，可抽出来
         */
    joinQueryData(qryData) {
      const qryArr = ['']
      for (const key in qryData) {
        if (Object.prototype.hasOwnProperty.call(qryData, key)) {
          qryArr.push(`${key}=${encodeURIComponent(qryData[key])}`)
        }
      }
      return qryArr.join('&')
    },
    /**
         * 图片加载成功
         */
    picLoad() {
      this.$emit('iframeloaded')
    },
  },
}
</script>
<style lang="less">
#picWrapper{
  .pic-error{
    width: 100%;
    height: 100%;
    position: relative;
    text-align: center;
  }
}
</style>
<style lang="less" scoped>
@import '~less/button.less';
.pic-loading{
  width: 100%;
  height: 100%;
  position: relative;
  .pic-loading-icon{
    background: url(./images/blue-loading.gif) no-repeat center;
    background-size: 50px;
    height: 100px;
    width: 100px;
    left: 50%;
    margin-left: -50px;
    top: 50%;
    margin-top: -50px;
    position: absolute;
    z-index: 1;
  }
  // p.s. 模糊背景图在loading的下面，所以加了z-index：-1
  .pic-loading-bg{
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    filter: blur(3px);
    -webkit-filter: blur(3px);
    -moz-filter: blur(3px);
    -ms-filter: blur(3px);
  }
}
</style>
